<template>
  <v-app :dark="darkTheme">
    <router-view />
    <GlobalSnackbar />
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import GlobalSnackbar from '@/components/GlobalSnackbar.vue'

export default {
  name: 'App',
  components: {
    GlobalSnackbar
  },
  computed: {
    ...mapState(['darkTheme'])
  }
}
</script>

